import { ErrorIcon, InfoIcon, SuccessIcon, WarningIcon } from '../../../Icons';
import type { CalloutProps } from '../..';
import { CalloutType } from '../..';
import * as Styled from './CalloutIcon.styled';

interface Props extends Pick<CalloutProps, 'type' | 'dark' | 'overrides'> {}

export const CalloutIcon = ({ type, overrides, dark }: Props) => {
  const renderIcon = () => {
    if (overrides?.Icon) {
      const CustomIcon = overrides.Icon;
      return <CustomIcon />;
    }
    switch (type) {
      case CalloutType.INFO:
        return <InfoIcon />;
      case CalloutType.ERROR:
        return <ErrorIcon />;
      case CalloutType.WARNING:
        return <WarningIcon />;
      case CalloutType.SUCCESS:
        return <SuccessIcon />;
      case CalloutType.NEUTRAL:
        return <InfoIcon />;
    }
  };

  if (!type) {
    return null;
  }

  return (
    <Styled.Wrapper $dark={dark} $overrides={overrides} $type={type}>
      {renderIcon()}
    </Styled.Wrapper>
  );
};
